import { PortableTextComponents } from '@portabletext/react';
import { StudioBaseImageV2 } from 'shared/studio/StudioBaseImage/StudioBaseImage';
import { BulletList, NumberedList } from './List/List';
import Link from './Marks/Link/Link';
import Sub from './Marks/Sub/Sub';
import Sup from './Marks/Sup/Sup';

export const serializers: PortableTextComponents = {
  types: {
    image: ({ value }) => <StudioBaseImageV2 image={value} />
  },
  marks: {
    sup: Sup,
    sub: Sub,
    link: Link,
    span: ({ children }) => <span>{children}</span>
  },
  list: {
    bullet: BulletList,
    number: NumberedList
  }
};
